import { baseUniDriverFactory as createBaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';

export const headingUniDriverFactory = base => {
  const baseUniDriver = createBaseUniDriver(base);

  return {
    ...baseUniDriver,

    /**
     * Gets text content
     * @returns {Promise<string>} innerHTML
     */
    getText: () => base._prop('innerHTML'),

    /**
     * Gets heading appearance
     * @returns {Promise<'H1' | 'H2' | 'H3' | 'H4' | 'H5' | 'H6'>}
     */
    getAppearance: () => base.attr('data-appearance'),

    /**
     * Gets heading size
     * @returns {Promise<'extraLarge' | 'large' | 'medium' | 'small' | 'tiny' | 'extraTiny'>}
     */
    getSize: () => base.attr('data-size'),

    /**
     * Gets heading tag name
     * @returns {Promise<keyof HTMLElementTagNameMap>}
     */
    getTagName: async () => baseUniDriver.element().then(el => el.tagName),

    /**
     * Checks whether heading is light
     * @return {Promise<boolean>}
     */
    isLight: async () => (await base.attr('data-light')) === 'true',

    /**
     * Checks if heading has masking classNames
     * @return {Promise<boolean>}
     */
    isMasked: async () => (await base.attr('data-mask')) === 'true',

    /**
     * Gets heading id
     * @returns {Promise<string>}
     */
    getId: () => base.attr('data-id'),
  };
};
